import type { AlertProps, BadgeProps } from "@mantine/core";
import type { NotificationData } from "@mantine/notifications";
import {
  IconAlertTriangleFilled,
  IconCheck,
  IconExclamationMark,
  IconInfoCircleFilled,
  IconX
} from "@tabler/icons-react";

export const AlertPresets = {
  error: { color: "error", icon: <IconAlertTriangleFilled /> },
  info: { color: "info", icon: <IconInfoCircleFilled /> },
  warning: { color: "warning", icon: <IconAlertTriangleFilled /> },
  success: { color: "success", icon: <IconCheck /> }
} as const satisfies Record<string, Partial<AlertProps>>;

export const BadgePresets = {
  error: { c: "error", bg: "error.2", bd: "1px solid error" },
  info: { c: "info", bg: "info.1", bd: "1px solid info" },
  warning: { c: "warning", bg: "warning.2", bd: "1px solid warning" },
  success: { c: "success", bg: "success.2", bd: "1px solid success" }
} as const satisfies Record<string, Partial<BadgeProps>>;

export const NotificationPresets = {
  error: { color: "error", icon: <IconX size="1.2rem" />, autoClose: 7000 },
  info: { color: "info", icon: undefined, autoClose: 7000 },
  warning: {
    color: "warning",
    icon: <IconExclamationMark size="1.2rem" />,
    autoClose: 7000
  },
  success: {
    color: "success",
    icon: <IconCheck size="1.2rem" />,
    autoClose: 3000
  }
} as const satisfies Record<string, Partial<NotificationData>>;
